import { render, staticRenderFns } from "./BiodataVerificationStatus.vue?vue&type=template&id=4f6a17f6"
import script from "./BiodataVerificationStatus.vue?vue&type=script&lang=js"
export * from "./BiodataVerificationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports